'use client';
import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';

import ErrorPageLayout, { getMetadata } from '@/app/components/ErrorPage';
import { Button } from '@/app/components/ui/Button';

export async function generateMetadata() {
  return getMetadata('500_title');
}

export default function GlobalError({
  error,
  reset,
}: {
  readonly error: Error & { digest?: string };
  readonly reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);
  return (
    <ErrorPageLayout
      name="500"
      description="Something went wrong, please try again."
      headline="500"
      title="Internal Server Error"
    >
      <Button className="max-w-fit" onClick={() => reset()}>
        Try again
      </Button>
    </ErrorPageLayout>
  );
}
